const convertStringDates = (message: any, dateProps: Array<string>) => {
  dateProps.forEach((propertyName) => {
    message[propertyName] =
      message[propertyName] !== undefined && message[propertyName] !== null
        ? new Date(message[propertyName]?.toString())
        : null;
  });
};
export default convertStringDates;
